module.exports = __webpack_public_path__ + "static/media/curso-ladder-treinamentos-site-768x591.bdfaae1e.jpg";